import { render, staticRenderFns } from "./AdminReporting.vue?vue&type=template&id=45eec216&scoped=true"
import script from "./AdminReporting.vue?vue&type=script&lang=ts"
export * from "./AdminReporting.vue?vue&type=script&lang=ts"
import style0 from "./AdminReporting.vue?vue&type=style&index=0&id=45eec216&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45eec216",
  null
  
)

export default component.exports